import { toast } from '@qodo/design-system';
import { useMutation } from '@tanstack/react-query';
import { spawn } from '../../utils/translations';
import {
  GitlabClient,
  GitlabLoginMTRequest,
} from '../httpClients/GitlabClient';
import { MUTATION_KEYS } from './consts';
import { getErrorToastContent } from './utils';

export const useLoginGitlabMTMutation = () => {
  const spawnToasts = spawn('toasts.gitlab.login');

  return useMutation({
    mutationKey: [MUTATION_KEYS.LOGIN_GITLAB_MT],
    mutationFn: async (request: GitlabLoginMTRequest) => {
      return await GitlabClient.loginMT(request);
    },
    onError: (err: any) => {
      const errorFromServer = getErrorToastContent(err, spawnToasts('error'));

      toast.error(errorFromServer);
    },
  });
};
